import { createApiPdfV2, createApiV2 } from "./common";

export const postGeneratePdf = (payload) => (token) =>
  createApiPdfV2("POST", "generate_pdf/", { responseType: "json" })(token, payload);

export const postGenerateDeliveryRunSheetPdf = (payload) => (token) =>
  createApiPdfV2("POST", "generate_pdf/run_sheet/", { responseType: "json" })(token, payload);

export const getCompanyTemplates = () => (token) =>
  createApiV2("GET", "pdf/company_templates/")(token);

export const getGlobalTemplates = () => (token) =>
  createApiV2("GET", "pdf/global_templates/")(token);

export const getDefaultTemplateByType = (type) => (token) =>
  createApiV2("GET", `pdf/default_template/?template_key=${type}`)(token);

export const postGenerateInvoice = (data) => (token) =>
  createApiV2("POST", "pdf/generate_invoice/")(token, data);

export const postGenerateProformaInvoice = (data) => (token) =>
  createApiV2("POST", "pdf/generate_proforma_invoice/")(token, data);

export const postGeneratePartialInvoice = (data) => (token) =>
  createApiV2("POST", "pdf/generate_partial_invoice/")(token, data);

export const postGenerateWorkOrder = (data) => (token) =>
  createApiV2("POST", "pdf/generate_work_order/")(token, data);

export const postGenerateQuote = (data) => (token) =>
  createApiV2("POST", "pdf/generate_quote/")(token, data);

export const postGeneratePurchaseOrder = (data) => (token) =>
  createApiV2("POST", "pdf/generate_purchase_order/")(token, data);

export const postGenerateDeliveryDocket = (data) => (token) =>
  createApiV2("POST", "pdf/generate_delivery_docket/")(token, data);

export const postGenerateRunSheet = (data) => (token) =>
  createApiV2("POST", "pdf/generate_runsheet/")(token, data);

export const postEmailPdf =
  ({ orderUid, customerUid, data }) =>
  (token) =>
    createApiV2("POST", `customers/${customerUid}/orders/${orderUid}/email/`)(token, data);

export const postPurchaseOrderEmailPdf =
  ({ purchaseOrderUid, data }) =>
  (token) =>
    createApiV2("POST", `purchasing/purchase_orders/${purchaseOrderUid}/email_pdf/`)(token, data);

export default {};
